module.exports = __webpack_public_path__ + "img/10_1_1_3.88e7f203.png";